import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import '../styles/layout/seasonal.scss';

const SeasonalCards = () => {
    const containerRef = useRef(null);
    const taxonomy = 'season';
    const termId = document.querySelector("#render-react-seasonal-cards").dataset.seasonid || 'summer';
    const perPage = document.querySelector("#render-react-seasonal-cards").dataset.perpage || 20;
  
    const [featPost, setFeatPost] = useState({'id' : ''});
    const [postTypes, setPostTypes] = useState(['posts', 'recipe']);
    const [posts, setPosts] = useState([]);
    const [pagenum, setPageNum] = useState(1);
    
    useEffect(() => {
      // Get the query parameter 'search' from the URL
      console.log('he')
      console.log(window.location);
      const searchParam = new URLSearchParams(window.location.search).get('featured');
  
      // Do something with the 'search' parameter
      if (searchParam) {
        console.log(`Search parameter is: ${searchParam}`);
        axios.get(`/wp-json/wp/v2/recipe?search=${searchParam}&${taxonomy}=${termId}&per_page=1&_embed=true`).then((response) => {
          console.log(response);
          console.log(response.data);
          setFeatPost(response.data[0]);
          setPosts(response.data);
        }).catch((err) => {
          console.log('Failed to fetch featured post');
          console.log(err);
        });
      }
    }, []);
    
    useEffect(() => {
      console.log('fetchPosts');
      const fetchPosts = async () => {
        console.log(posts);
        const temp_posts = [];
        let empty_postType = [];
        await Promise.all(
          postTypes.map(async postType => {
            try {
              const response = await axios.get(`/wp-json/wp/v2/${postType}?_embed=true&${taxonomy}=${termId}&per_page=${perPage}&page=${pagenum}&exclude=${featPost.id}`);
              console.log(`/wp-json/wp/v2/${postType}?_embed=true&${taxonomy}=${termId}&per_page=${perPage}&page=${pagenum}`);
              console.log(response.data);
              console.log(response.data.length);
              console.log(perPage);
              if(response.data.length < perPage){
                console.log("Empty post type!");
                empty_postType.push(postType);
              }
              temp_posts.push(...response.data.map(item => ({ ...item, type: postType })));
            } catch (error) {
              if(error.response.message == 'The page number requested is larger than the number of pages available.'){
                //console.log("Exhausted post type");
              } else {
                console.error(`Error fetching ${postType} posts:`, error);
              }
            }
          })
        );
        temp_posts.sort((a, b) => new Date(b.date) - new Date(a.date));
        if(empty_postType !== []){
          setPostTypes(postTypes.filter(type => !empty_postType.includes(type)));
        };
        if(pagenum > 1 || posts !== []){
          setPosts(prevPosts => [...prevPosts, ...temp_posts]);
        } else {
          setPosts(temp_posts);
        }
      };
    fetchPosts();
  }, [taxonomy, termId, pagenum]);
  
  

    
  
    return (
      <>
        <Search postTypes={postTypes} term_id={termId} taxonomy={taxonomy} />
        <div className='seasonal__cards' >
            {posts.map(post => {  
              if (post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'].data && post._embedded['wp:featuredmedia'].data.status >= 400){
                console.log("Skipping a post due to lack of featuredmeda",post);
                return false;
              }
              return (
                <article className={post.type} key={post.id} id={sanitizeTitle(post.title.rendered)}>
                    <img 
                        src={(post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large !== undefined)? post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.source_url : post._embedded['wp:featuredmedia'][0].media_details.sizes.medium.source_url} 
                        width={(post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large !== undefined) ? post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.width : post._embedded['wp:featuredmedia'][0].media_details.sizes.medium.width } 
                        height={(post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large !== undefined) ? post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.height : post._embedded['wp:featuredmedia'][0].media_details.sizes.medium.height}
                    />
                    <header>
                        <h2 dangerouslySetInnerHTML={{ __html:post.title.rendered}}></h2>
                    </header>
                    <div className='card__content' dangerouslySetInnerHTML={{ __html: post.excerpt.rendered !== '' ? (post.excerpt.rendered) : post.content.rendered.substring(0, 50) + (post.content.rendered.length > 50 ? '...' : '') }}></div>
                    <footer>
                        <a class="button-arrow" href={post.link} aria-description="View post" target="_self">
                            {post.type === 'recipe' ? "See Recipe" : "Read Article"}
                        </a>
                    </footer>
                </article>
            )})}
        </div>
        <LoadMore pagenum={pagenum} setPageNum={setPageNum} posts={posts} postTypes={postTypes}/>
      </>
    );

  };

const LoadMore = ({ pagenum, setPageNum, posts, postTypes }) => {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
  
    // Create an IntersectionObserver to detect when the component is visible
    useEffect(() => {
      if(posts.length == 0 || postTypes.length == 0){
        setIsVisible(false);
        return;
      }
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting && postTypes.length !== 0) {
            console.log("isVisible!");
            console.log(postTypes);
            setIsVisible(true);
            setPageNum((prevPageNum) => prevPageNum + 1);
            observer.disconnect(); // Disconnect the observer once the component is visible
          }
        },
        { root: null, rootMargin: '0px', threshold: 0.5 }
      );
  
      if (ref.current) {
        observer.observe(ref.current);
      }
  
      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    }, [posts]);
    
    return (
      <div ref={ref} className={isVisible ? 'load-more ellipsis-animation thinking' : 'load-more ellipsis-animation' }>
        <span>.</span><span>.</span><span>.</span>
      </div>
    );
  };

const Search = ({postTypes, term_id, taxonomy}) => {
    const compRef = useRef(null);
    const [result, setResult] = useState([]);

    const handleSubmit = async (e) => {
        // console.log(`/wp-json/wp/v2/${post_type}?search=${e.target.value}&${taxonomy}=${term_id}`)
        console.log('handleInputChange');
        let shouldUpdate = true;

        if(e.target.value == ''){
            console.log('value null, return');
            setResult([]);
            shouldUpdate = false;
        } else {
          const temp_posts = [];
          console.log("searching..."+e.target.value);
          await Promise.all(
              postTypes.map(async post_type => {
                  try {
                      const response = await axios.get(`/wp-json/wp/v2/${post_type}?search=${e.target.value}&${taxonomy}=${term_id}&per_page=4&orderby=date`);
                      temp_posts.push(...response.data.map(item => ({ ...item, type: post_type })));
                  } catch (error) {
                      console.error(`Error fetching ${post_type} posts:`, error);
                  }
              })
          );
          console.log('fetched posts');
          console.log(temp_posts);
          // if(display_container.post == temp_posts[0].id){
          //   return
          // } else {
          //   display_container.innerHTML = '';
          // }
          if(temp_posts.length > 0 && shouldUpdate){
            setResult(temp_posts);
          }
        }
    };

    return (
        <div className='seasonal__search' ref={compRef}>
          <input
            type='text'
            placeholder='Search for...'
            onChange={handleSubmit}
          />
          <button class="search-button" onClick={handleSubmit}>
              <span class="search-icon"></span>
          </button>
          <div class="ellipsis-animation">
              <span>.</span>
              <span>.</span>
              <span>.</span>
          </div>
          <div id='results'>
            {result.map(post => (
              <a key={post.id} class="leaf leaf--light_green" href={post.link} aria-description="View post" target="_self" dangerouslySetInnerHTML={{ __html:post.title.rendered}}></a>
            ))}
          </div>
        </div>
      );
  }

  function sanitizeTitle(inputString) {
    // Convert to lowercase
    const lowercaseString = inputString.toLowerCase();
  
    // Replace spaces with hyphens and remove unsafe characters
    const sanitizedString = lowercaseString
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, '') // Remove unsafe characters (anything that is not a letter, digit, or hyphen)
  
    return sanitizedString;
  }
  
  export default SeasonalCards;
  